const locale = {
  login: 'iniciar sesión',
  copyright: 'derechos de autor',
  'terms & privacy': 'Términos & privacidad',
  'build your company': 'Construye tu empresa',
  'tradability score': 'puntuación de comerciabilidad',
  'check your score': 'Comprueba tu puntuación',
  'boost your score': 'aumenta tu puntaje',
};

export default locale;
